import { render, staticRenderFns } from "./disburseRecord.vue?vue&type=template&id=0db903e3"
import script from "./disburseRecord.vue?vue&type=script&lang=js"
export * from "./disburseRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports